'use strict';

var cov_2mtnjktmi2 = function () {
  var path = '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/filter/lib/reducer.js',
      hash = 'b3e7f1c5e2dfe6be1c630cf1777c04b305534621',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/filter/lib/reducer.js',
    statementMap: {
      '0': {
        start: {
          line: 5,
          column: 21
        },
        end: {
          line: 10,
          column: 1
        }
      },
      '1': {
        start: {
          line: 12,
          column: 25
        },
        end: {
          line: 13,
          column: 93
        }
      },
      '2': {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 93
        }
      },
      '3': {
        start: {
          line: 13,
          column: 34
        },
        end: {
          line: 13,
          column: 92
        }
      },
      '4': {
        start: {
          line: 13,
          column: 52
        },
        end: {
          line: 13,
          column: 64
        }
      },
      '5': {
        start: {
          line: 20,
          column: 20
        },
        end: {
          line: 29,
          column: 1
        }
      },
      '6': {
        start: {
          line: 21,
          column: 12
        },
        end: {
          line: 21,
          column: 17
        }
      },
      '7': {
        start: {
          line: 22,
          column: 12
        },
        end: {
          line: 22,
          column: 17
        }
      },
      '8': {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 27,
          column: 3
        }
      },
      '9': {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 14
        }
      },
      '10': {
        start: {
          line: 25,
          column: 9
        },
        end: {
          line: 27,
          column: 3
        }
      },
      '11': {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 13
        }
      },
      '12': {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 11
        }
      },
      '13': {
        start: {
          line: 31,
          column: 31
        },
        end: {
          line: 32,
          column: 71
        }
      },
      '14': {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 71
        }
      },
      '15': {
        start: {
          line: 32,
          column: 33
        },
        end: {
          line: 32,
          column: 70
        }
      },
      '16': {
        start: {
          line: 34,
          column: 15
        },
        end: {
          line: 137,
          column: 1
        }
      },
      '17': {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 136,
          column: 3
        }
      },
      '18': {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 42,
          column: 8
        }
      },
      '19': {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 48,
          column: 8
        }
      },
      '20': {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 60,
          column: 8
        }
      },
      '21': {
        start: {
          line: 55,
          column: 12
        },
        end: {
          line: 55,
          column: 60
        }
      },
      '22': {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 74,
          column: 8
        }
      },
      '23': {
        start: {
          line: 67,
          column: 43
        },
        end: {
          line: 67,
          column: 94
        }
      },
      '24': {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 81,
          column: 8
        }
      },
      '25': {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 88,
          column: 8
        }
      },
      '26': {
        start: {
          line: 90,
          column: 40
        },
        end: {
          line: 90,
          column: 42
        }
      },
      '27': {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 97,
          column: 8
        }
      },
      '28': {
        start: {
          line: 94,
          column: 8
        },
        end: {
          line: 96,
          column: 70
        }
      },
      '29': {
        start: {
          line: 95,
          column: 27
        },
        end: {
          line: 95,
          column: 73
        }
      },
      '30': {
        start: {
          line: 96,
          column: 34
        },
        end: {
          line: 96,
          column: 68
        }
      },
      '31': {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 101,
          column: 8
        }
      },
      '32': {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 114,
          column: 8
        }
      },
      '33': {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 120,
          column: 8
        }
      },
      '34': {
        start: {
          line: 119,
          column: 35
        },
        end: {
          line: 119,
          column: 72
        }
      },
      '35': {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 124,
          column: 8
        }
      },
      '36': {
        start: {
          line: 126,
          column: 6
        },
        end: {
          line: 133,
          column: 8
        }
      },
      '37': {
        start: {
          line: 135,
          column: 6
        },
        end: {
          line: 135,
          column: 19
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 12,
            column: 25
          },
          end: {
            line: 12,
            column: 26
          }
        },
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 93
          }
        },
        line: 13
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 13,
            column: 15
          },
          end: {
            line: 13,
            column: 16
          }
        },
        loc: {
          start: {
            line: 13,
            column: 34
          },
          end: {
            line: 13,
            column: 92
          }
        },
        line: 13
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 13,
            column: 42
          },
          end: {
            line: 13,
            column: 43
          }
        },
        loc: {
          start: {
            line: 13,
            column: 52
          },
          end: {
            line: 13,
            column: 64
          }
        },
        line: 13
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 20,
            column: 20
          },
          end: {
            line: 20,
            column: 21
          }
        },
        loc: {
          start: {
            line: 20,
            column: 38
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 20
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 31,
            column: 31
          },
          end: {
            line: 31,
            column: 32
          }
        },
        loc: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 71
          }
        },
        line: 32
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 32,
            column: 15
          },
          end: {
            line: 32,
            column: 16
          }
        },
        loc: {
          start: {
            line: 32,
            column: 33
          },
          end: {
            line: 32,
            column: 70
          }
        },
        line: 32
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 34,
            column: 15
          },
          end: {
            line: 34,
            column: 16
          }
        },
        loc: {
          start: {
            line: 34,
            column: 68
          },
          end: {
            line: 137,
            column: 1
          }
        },
        line: 34
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 54,
            column: 38
          },
          end: {
            line: 54,
            column: 39
          }
        },
        loc: {
          start: {
            line: 55,
            column: 12
          },
          end: {
            line: 55,
            column: 60
          }
        },
        line: 55
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 67,
            column: 32
          },
          end: {
            line: 67,
            column: 33
          }
        },
        loc: {
          start: {
            line: 67,
            column: 43
          },
          end: {
            line: 67,
            column: 94
          }
        },
        line: 67
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 91,
            column: 51
          },
          end: {
            line: 91,
            column: 52
          }
        },
        loc: {
          start: {
            line: 91,
            column: 58
          },
          end: {
            line: 97,
            column: 7
          }
        },
        line: 91
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 95,
            column: 15
          },
          end: {
            line: 95,
            column: 16
          }
        },
        loc: {
          start: {
            line: 95,
            column: 27
          },
          end: {
            line: 95,
            column: 73
          }
        },
        line: 95
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 96,
            column: 16
          },
          end: {
            line: 96,
            column: 17
          }
        },
        loc: {
          start: {
            line: 96,
            column: 34
          },
          end: {
            line: 96,
            column: 68
          }
        },
        line: 96
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 119,
            column: 27
          },
          end: {
            line: 119,
            column: 28
          }
        },
        loc: {
          start: {
            line: 119,
            column: 35
          },
          end: {
            line: 119,
            column: 72
          }
        },
        line: 119
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        }, {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        }],
        line: 23
      },
      '1': {
        loc: {
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 27,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 27,
            column: 3
          }
        }, {
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 27,
            column: 3
          }
        }],
        line: 25
      },
      '2': {
        loc: {
          start: {
            line: 34,
            column: 16
          },
          end: {
            line: 34,
            column: 55
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 34,
            column: 24
          },
          end: {
            line: 34,
            column: 55
          }
        }],
        line: 34
      },
      '3': {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 136,
            column: 3
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 42,
            column: 8
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 48,
            column: 8
          }
        }, {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 60,
            column: 8
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 74,
            column: 8
          }
        }, {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 81,
            column: 8
          }
        }, {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 88,
            column: 8
          }
        }, {
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        }, {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 115,
            column: 5
          }
        }, {
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 124,
            column: 8
          }
        }, {
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 133,
            column: 8
          }
        }, {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 135,
            column: 19
          }
        }],
        line: 36
      },
      '4': {
        loc: {
          start: {
            line: 64,
            column: 32
          },
          end: {
            line: 71,
            column: 14
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 65,
            column: 12
          },
          end: {
            line: 70,
            column: 13
          }
        }, {
          start: {
            line: 71,
            column: 12
          },
          end: {
            line: 71,
            column: 14
          }
        }],
        line: 64
      },
      '5': {
        loc: {
          start: {
            line: 96,
            column: 34
          },
          end: {
            line: 96,
            column: 68
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 96,
            column: 62
          },
          end: {
            line: 96,
            column: 63
          }
        }, {
          start: {
            line: 96,
            column: 66
          },
          end: {
            line: 96,
            column: 68
          }
        }],
        line: 96
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0],
      '3': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      '4': [0, 0],
      '5': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _model = require('./model');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = (cov_2mtnjktmi2.s[0]++, {
  filterCriteria: _constants.DefaultFilterCriteria,
  filterByTab: {},
  LOADING: false,
  ERROR: false
});

cov_2mtnjktmi2.s[1]++;
var removeDuplicates = function removeDuplicates(myArr, prop) {
  cov_2mtnjktmi2.f[0]++;
  cov_2mtnjktmi2.s[2]++;
  return myArr.filter(function (obj, pos, arr) {
    cov_2mtnjktmi2.f[1]++;
    cov_2mtnjktmi2.s[3]++;
    return arr.map(function (mapObj) {
      cov_2mtnjktmi2.f[2]++;
      cov_2mtnjktmi2.s[4]++;
      return mapObj[prop];
    }).indexOf(obj[prop]) === pos;
  });
};

/**
 * Method to compare two items by alphabetical order
 * @param {string} item1, first item to compare
 * @param {string} item2, second item to compare
 */
cov_2mtnjktmi2.s[5]++;
var sortByValue = function sortByValue(item1, item2) {
  cov_2mtnjktmi2.f[3]++;

  var x = (cov_2mtnjktmi2.s[6]++, item1);
  var y = (cov_2mtnjktmi2.s[7]++, item2);
  cov_2mtnjktmi2.s[8]++;
  if (x < y) {
    cov_2mtnjktmi2.b[0][0]++;
    cov_2mtnjktmi2.s[9]++;

    return -1;
  } else {
      cov_2mtnjktmi2.b[0][1]++;
      cov_2mtnjktmi2.s[10]++;
      if (x > y) {
        cov_2mtnjktmi2.b[1][0]++;
        cov_2mtnjktmi2.s[11]++;

        return 1;
      } else {
        cov_2mtnjktmi2.b[1][1]++;
      }
    }cov_2mtnjktmi2.s[12]++;
  return 0;
};

cov_2mtnjktmi2.s[13]++;
var sortOptionsDataByLabel = function sortOptionsDataByLabel(options) {
  cov_2mtnjktmi2.f[4]++;
  cov_2mtnjktmi2.s[14]++;
  return options.sort(function (item1, item2) {
    cov_2mtnjktmi2.f[5]++;
    cov_2mtnjktmi2.s[15]++;
    return sortByValue(item1.label, item2.label);
  });
};

cov_2mtnjktmi2.s[16]++;
var filter = function filter() {
  var _extends2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2mtnjktmi2.b[2][0]++, (0, _assign2.default)({}, initialState));
  var action = arguments[1];
  cov_2mtnjktmi2.f[6]++;

  var tabFilterCriteria = void 0;
  cov_2mtnjktmi2.s[17]++;
  switch (action.type) {
    case _constants.FilterActionType.FILTER_BAR_BEFORE_LOAD_DATA:
      cov_2mtnjktmi2.b[3][0]++;
      cov_2mtnjktmi2.s[18]++;

      return (0, _extends5.default)({}, state, {
        LOADING: true,
        ERROR: false
      });
    case _constants.FilterActionType.FILTER_LOAD_DATA_ERROR:
      cov_2mtnjktmi2.b[3][1]++;
      cov_2mtnjktmi2.s[19]++;

      return (0, _extends5.default)({}, state, {
        LOADING: false,
        ERROR: true
      });
    case _constants.FilterActionType.FILTER_LOAD_DATA_SUCCESS:
      cov_2mtnjktmi2.b[3][2]++;
      cov_2mtnjktmi2.s[20]++;

      // This method is gonna produce filterData such as teamData, siteData, spaceData, topicData
      return (0, _extends5.default)({}, state, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, action.filterName + 'Data', sortOptionsDataByLabel((0, _get2.default)(action, 'data', []).map(function (filterItem) {
        cov_2mtnjktmi2.f[7]++;
        cov_2mtnjktmi2.s[21]++;
        return _model.SingleOptionModel.get(filterItem, action.config);
      }))), (0, _defineProperty3.default)(_extends2, 'LOADING', false), (0, _defineProperty3.default)(_extends2, 'ERROR', false), _extends2));
    case _constants.FilterActionType.FILTER_BAR_LOAD_HOSPITALITY_SESSION_DATA_SUCCESS:
      cov_2mtnjktmi2.b[3][3]++;
      cov_2mtnjktmi2.s[22]++;

      return (0, _extends5.default)({}, state, {
        hospitalitySessionData: Array.isArray(action.data) ? (cov_2mtnjktmi2.b[4][0]++, sortOptionsDataByLabel(removeDuplicates(action.data.map(function (session) {
          cov_2mtnjktmi2.f[8]++;
          cov_2mtnjktmi2.s[23]++;
          return _model.SingleOptionModel.get(session, action.config, true);
        }), 'value'))) : (cov_2mtnjktmi2.b[4][1]++, []),
        LOADING: false,
        ERROR: false
      });
    case _constants.FilterActionType.FILTER_BAR_LOAD_HOSPITALITY_TYPE_SUCCESS:
      cov_2mtnjktmi2.b[3][4]++;
      cov_2mtnjktmi2.s[24]++;

      return (0, _extends5.default)({}, state, {
        hospitalityTypeData: sortOptionsDataByLabel(_constants.HospitalityTypeOtions),
        LOADING: false,
        ERROR: false
      });
    case _constants.FilterActionType.FILTER_BAR_LOAD_ODER_PRODUCT_TYPE_SUCCESS:
      cov_2mtnjktmi2.b[3][5]++;
      cov_2mtnjktmi2.s[25]++;

      return (0, _extends5.default)({}, state, {
        orderProductTypeData: sortOptionsDataByLabel(_constants.OrderProductTypeOptions),
        LOADING: false,
        ERROR: false
      });
    case _constants.FilterActionType.FILTER_BAR_LOAD_PRODUCT_TYPES_SUCCESS:
      cov_2mtnjktmi2.b[3][6]++;
      {
        var productTypesDataByTabCode = (cov_2mtnjktmi2.s[26]++, {});
        cov_2mtnjktmi2.s[27]++;
        action.customProductTypeByProductTab.forEach(function (tab) {
          cov_2mtnjktmi2.f[9]++;
          cov_2mtnjktmi2.s[28]++;

          // Convert product types from catalog summary to standard option data for dropdown filter
          // Sort by product type name (label)
          productTypesDataByTabCode[tab.code] = tab.productTypes.map(function (prodType) {
            cov_2mtnjktmi2.f[10]++;
            cov_2mtnjktmi2.s[29]++;
            return _model.SingleOptionModel.get(prodType, action.config);
          }).sort(function (typeA, typeB) {
            cov_2mtnjktmi2.f[11]++;
            cov_2mtnjktmi2.s[30]++;
            return typeA.label > typeB.label ? (cov_2mtnjktmi2.b[5][0]++, 1) : (cov_2mtnjktmi2.b[5][1]++, -1);
          });
        });
        cov_2mtnjktmi2.s[31]++;
        return (0, _extends5.default)({}, state, {
          productTypesDataByTabCode: productTypesDataByTabCode
        });
      }
    case _constants.FilterActionType.FILTER_APPLY:
      cov_2mtnjktmi2.b[3][7]++;
      {
        cov_2mtnjktmi2.s[32]++;

        return (0, _extends5.default)({}, state, {
          filterCriteria: (0, _extends5.default)({}, state.filterCriteria, action.data.filterCriteria),
          filterByTab: (0, _extends5.default)({}, state.filterByTab, action.data.filterByTab)
        });
      }
    case _constants.FilterActionType.FILTER_INITIALIZATION:
      cov_2mtnjktmi2.b[3][8]++;
      cov_2mtnjktmi2.s[33]++;

      tabFilterCriteria = _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)(action.data.map(function (tab) {
        cov_2mtnjktmi2.f[12]++;
        cov_2mtnjktmi2.s[34]++;
        return (0, _defineProperty3.default)({}, tab.code, _constants.DefaultFilterCriteria);
      }))));
      cov_2mtnjktmi2.s[35]++;
      return (0, _extends5.default)({}, state, {
        filterByTab: tabFilterCriteria
      });
    case _constants.FilterActionType.FILTER_RESET:
      cov_2mtnjktmi2.b[3][9]++;
      cov_2mtnjktmi2.s[36]++;

      return (0, _extends5.default)({}, state, {
        filterCriteria: _constants.DefaultFilterCriteria, // reset to default filter criteria
        filterByTab: (0, _extends5.default)({}, state.filterByTab, (0, _defineProperty3.default)({}, action.data, _constants.DefaultFilterCriteria))
      });
    default:
      cov_2mtnjktmi2.b[3][10]++;
      cov_2mtnjktmi2.s[37]++;

      return state;
  }
};

exports.default = filter;